import { ParalegalAbilities } from './ability';
import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext(ParalegalAbilities);
export const Can = createContextualCan(AbilityContext.Consumer);
export default Can;
